/**
 * Middleware to check if the user is authenticated
 * redirects to the auth page if not
 */
export default defineNuxtRouteMiddleware(async (to, _from) => {
    const user = useSupabaseUser()

    if (!user.value || user.value.is_anonymous) {
        return navigateTo(Urls.Auth({ redirectAfter: to.fullPath }))
    }
})
